import type { PayloadAction } from '@reduxjs/toolkit';

import { PromoOfferEnabledState, SET_PROMO_OFFER_ENABLED } from './types';

const initialState: PromoOfferEnabledState = false;

export function promoOfferEnabledReducer(
	state = initialState,
	action: PayloadAction<PromoOfferEnabledState>,
): PromoOfferEnabledState {
	switch (action.type) {
		case SET_PROMO_OFFER_ENABLED:
			return action.payload;
		default:
			return state;
	}
}
